import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var TenantBilling = Class.create({
  	initialize: function() {
	},
	getBillingInformation: function(callback) {
		var url = "tenant/stripe/account";
		var params = data;
		var data = server.getData(url,params, true);
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
		});
    },
    saveBillingInformation: function(data, callback) {
		var url = "tenant/stripe/createaccount";
		var params = data;
		var data = server.getData(url,params, true, "POST");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error!  ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error!  ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    updateAutoPayOption: function(autoPay, callback) {
        var url = "tenant/autopay";
		var params = {
            autoPay: autoPay
        };
		var data = server.getData(url, params, true, "PUT");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
    },
    pay: function(charge, transactionId, usingCC, callback) {
        var url = "tenant/pay";
		var params = {
			charge: charge,
            usingCC: usingCC,
			transactionId: transactionId
        };
		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	payManual: function(charge, processingFee, description, callback) {
        var url = "tenant/pay/manual";
		var params = {
			charge: charge,
			processingFee: processingFee,
			description: description
        };
		var data = server.getData(url, params, true, "POST");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	getTransactionHistory: function(callback) {
		var url = "tenant/transaction/history";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getTransactionHistoryWithId: function(callback, tenant_id) {
		var url = "tenant/transaction/history/" + tenant_id;
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
                if(callback) {
                    callback(response);
                }
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getLatestInvoice: function(callback) {
		var url = "tenant/rent/bill/latest";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong.", "danger", "top", "center");
		});
	},
	deleteTransaction: function(data, callback) {
		var url = "tenant/billing/delete/invoice/" + data.tenant_payment_history_id;
		var params = data;
		var data = server.getData(url, params, true, 'DELETE');
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	markInvoicePaid: function(data, callback) {
		var url = "tenant/billing/invoice/paid/" + data.tenant_payment_history_id;
		var params = data;
		var data = server.getData(url, params, true, 'PUT');
		data
		.done(function(response){
			if (response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if (response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			} else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
	},
	updatePaymentDate: function(data, dueDate, callback) {
		var url 			= "tenant/billing/invoice/paymentdate/" + data.tenant_payment_history_id;
		var params 			= data;
		params['new_date'] 	= dueDate;
		var data = server.getData(url, params, true, 'PUT');
		data
		.done(function(response){
			if(response.status === 'ERROR') {
				modal.showInfo('Error! ' + JSON.parse(response.message.httpBody).error.message, 'danger', 'top', 'center');
			} else if(response.status == 'ERROR_INTERNAL') {
				modal.showInfo('Error! ' + response.message[0], 'danger', 'top', 'center');
			}else {
				callback(response);
			}
		})
		.fail(function(e){
            if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
});

export let tenantBilling = new TenantBilling();


// WEBPACK FOOTER //
// app/core/controllers/TenantBilling.js